module.exports = __webpack_public_path__ + "static/media/bew.c5377d59.svg";